(function(){
  "use strict";
  var $ = function(id){ return document.getElementById(id); };
  var THUMB = function(k){ return IMG[k + "_t"] || IMG[k]; };
  var money = function(n){ return "$" + Number(n).toFixed(2); };
  window.__pdpErrors = [];
  window.addEventListener("error", function(e){ window.__pdpErrors.push(String(e.message)); });

  var DATA = JSON.parse(document.getElementById("spw-pdp-data").textContent);
  var KITS = DATA.formulas, ORDER = DATA.order, GROUPS = DATA.groups || [];
  var COMPONENTS = window.SPW_KIT_COMPONENTS || {};
  var IMG = DATA.img;
  var CUR = DATA.current, F = KITS[CUR], VARIANTS = F.variants, GAL = F.gal;
  (function(){
    var byHandle = window.SPW_KIT_ITEMS || {};
    Object.keys(KITS).forEach(function(k){
      var kit = KITS[k], rows = byHandle[kit.handle] || {};
      (kit.variants || []).forEach(function(v){ v.items = rows[v.sku] || rows[v.t] || []; });
    });
  })();

  (function overlayKitCopy(){
    var C = window.SPW_CONTENT || {};
    Object.keys(KITS).forEach(function(k){
      if(C[k] && C[k].bestLine) KITS[k].bestLine = C[k].bestLine;
      if(C[k] && C[k].oneLiner) KITS[k].oneLiner = C[k].oneLiner;
      if(C[k] && C[k].blurb) KITS[k].blurb = C[k].blurb;
    });
  })();
  var sel = 0, galIdx = 0;

  /* ---------- gallery ---------- */
  function paintGallery(){
    if(!GAL.length) return;
    if(galIdx >= GAL.length) galIdx = 0;
    $("galimg").src = IMG[GAL[galIdx]];
    $("galimg").alt = F.name;
    $("galn").textContent = galIdx + 1;
    $("galtot").textContent = GAL.length;
    [].forEach.call($("thumbs").children, function(b, i){
      b.setAttribute("aria-current", i === galIdx ? "true" : "false");
    });
  }
  function buildThumbs(){
    $("thumbs").innerHTML = GAL.map(function(k, i){
      return '<button type="button" aria-label="Image ' + (i+1) + '"><img src="' + THUMB(k) + '" alt=""></button>';
    }).join("");
    [].forEach.call($("thumbs").children, function(b, i){
      b.addEventListener("click", function(){ galIdx = i; paintGallery(); });
    });
  }
  $("prev").addEventListener("click", function(){ galIdx = (galIdx - 1 + GAL.length) % GAL.length; paintGallery(); });
  $("next").addEventListener("click", function(){ galIdx = (galIdx + 1) % GAL.length; paintGallery(); });

  /* ---------- variant chips ---------- */
  function firstBuyable(){
    for(var i = 0; i < VARIANTS.length; i++) if(VARIANTS[i].avail) return i;
    // nothing sellable: open on an option whose contents are documented, so the
    // page does not land on its one blank breakdown
    for(var j = 0; j < VARIANTS.length; j++) if(VARIANTS[j].items.length) return j;
    return 0;
  }
  function buildSizes(host, after){
    host.innerHTML = VARIANTS.map(function(v, i){
      var out = !v.avail;
      return '<button type="button" class="szbtn" data-out="' + (out ? 1 : 0) + '" aria-pressed="' +
        (i === sel ? "true" : "false") + '">' + v.t +
        '<small>' + (out ? "Sold out" : money(v.price)) + '</small></button>';
    }).join("");
    [].forEach.call(host.children, function(b, i){
      b.addEventListener("click", function(){ sel = i; render(); if(after) after(); });
    });
  }

  /* ---------- price + stock ---------- */
  function paintPrice(){
    var v = VARIANTS[sel];
    var save = (v.cmp && v.cmp > v.price) ? Math.round((1 - v.price / v.cmp) * 100) : 0;
    $("pricerow").innerHTML =
      '<span class="now">' + money(v.price) + '</span>' +
      (v.cmp && v.cmp > v.price ? '<s>' + money(v.cmp) + '</s>' : "") +
      (save ? '<span class="save">Save ' + save + '%</span>' : "");
    // Pro price comes straight off custom.pro_variant_price where the store has it,
    // which is exactly 20%. The two consumer starter kits carry none, so show none.
    $("prowrap").innerHTML = v.pro
      ? '<span class="propill" id="propill">PRO PRICE ' + money(v.pro) + ' \u00b7 save 20%</span>'
      : "";
    var st = $("stockState");
    st.textContent = v.avail ? "In stock" : "Sold out";
    st.className = "state " + (v.avail ? "in" : "out");
    $("notice").innerHTML = v.avail ? "" :
      '<div class="notice out"><b>' + v.t + '</b> is sold out. Every other option on this kit is listed above.</div>';
    $("atc").textContent = v.avail ? "Add to cart " + money(v.price) : "Sold out";
    $("atc").disabled = !v.avail;
  }

  /* ---------- what is in the kit --------------------------------------
     The whole reason this section exists: contents differ per option, and
     nothing on the live page says what they are. */
  function paintKit(){
    var v = VARIANTS[sel];
    $("kitFor").textContent = v.t;
    $("kitSub").textContent = v.items.length
      ? "Every item in this option. Open any of them to read more."
      : "Contents for this option are not documented yet.";
    if(!v.items.length){
      $("kitList").innerHTML = '<div class="kit-none">We have not published the contents for this option yet, and this page will not guess at them. Pick another option above to see everything it includes.</div>';
      $("kitNote").textContent = "";
      return;
    }
    $("kitList").innerHTML = v.items.map(function(it){
      var c = it.h ? COMPONENTS[it.h] : null;
      var img = (c && c.i) ? (IMG[c.i] || c.i) : "";
      var card = c
        ? '<div class="kit-card">' +
            (img ? '<img src="' + img + '" alt="">' : '<span></span>') +
            '<div><div class="ct">' + c.t + '</div><p>' + c.d + '</p>' +
            '<button type="button" class="kit-add" data-h="' + it.h + '">Add to cart</button></div></div>'
        : "";
      return '<div class="kit-row" data-link="' + (c ? 1 : 0) + '"' +
        (c ? ' data-u="' + c.u + '"' : "") + '>' +
        '<span class="kit-x">' + it.q + 'x</span>' +
        (img ? '<img class="kit-img" src="' + img + '" alt="' + (c ? c.t : it.n) + '">'
             : '<span class="kit-img"></span>') +
        (c ? '<a class="kit-n" href="' + c.u + '" target="_blank" rel="noopener">' + it.n + '</a>'
           : '<span class="kit-n">' + it.n + '</span>') +
        '<span class="kit-go">' + (c ? "View" : "") + '</span>' + card + '</div>';
    }).join("");

    // whole row opens the product, except when the click is the Add button
    [].forEach.call($("kitList").querySelectorAll('.kit-row[data-link="1"]'), function(row){
      row.addEventListener("click", function(e){
        if(e.target.closest(".kit-add")) return;
        if(e.target.closest("a")) return;          // the link handles itself
        window.open(row.getAttribute("data-u"), "_blank", "noopener");
      });
    });
    [].forEach.call($("kitList").querySelectorAll(".kit-add"), function(b){
      b.addEventListener("click", function(e){
        e.preventDefault(); e.stopPropagation();
        var c = COMPONENTS[b.getAttribute("data-h")];
        cart++; $("cartcount").textContent = cart;
        b.setAttribute("data-added", "1");
        b.textContent = "Added";
        setTimeout(function(){ b.removeAttribute("data-added"); b.textContent = "Add to cart"; }, 1600);
        showToast((c ? c.t : "Item") + " added");
      });
    });

    var undoc = VARIANTS.filter(function(x){ return !x.items.length; }).length;
    $("kitNote").textContent = undoc
      ? undoc + " of this kit's " + VARIANTS.length + " options have no contents recorded yet."
      : "";
  }

  /* ---------- copy ---------- */
  function paintCopy(){
    $("h1").textContent = F.name;
    $("crumb").textContent = F.name;
    $("crumbFam").textContent = "Kits";
    $("oneliner").textContent = F.oneLiner;
    $("blurb").textContent = F.blurb;
    var r = F.rating || 0;
    $("ratingVal").textContent = r ? r.toFixed(2) : "New";
    $("ratingCount").textContent = F.reviews ? (F.reviews + (F.reviews === 1 ? " review" : " reviews")) : "No reviews yet";
    $("ratingStars").textContent = "\u2605\u2605\u2605\u2605\u2605".slice(0, Math.max(1, Math.round(r))) || "\u2606";
    paintReviewHead();
  }


  /* ---------- reviews: real Judge.me records ---------- */
  function stars(n){ return "\u2605\u2605\u2605\u2605\u2605".slice(0, Math.max(0, n)) +
                            "\u2606\u2606\u2606\u2606\u2606".slice(0, Math.max(0, 5 - n)); }
  function paintReviewHead(){
    var r = F.rating || 0, n = F.reviews || 0, shown = (F.rv || []).length;
    $("rvSub").textContent = n
      ? "Verified Judge.me reviews, pulled from the live page."
      : "This kit has no reviews yet.";
    $("rvHead").innerHTML = n
      ? '<span class="big">' + r.toFixed(2) + '</span><span class="st">' + stars(Math.round(r)) + '</span>' +
        '<span class="cnt">from ' + n + (n === 1 ? " review" : " reviews") + '</span>'
      : '<span class="cnt">No reviews recorded for this kit.</span>';
    $("rvSortWrap").hidden = shown < 2;
    $("rvMore").textContent = (n > shown)
      ? "Showing the " + shown + " most recent of " + n + "."
      : "";
    paintReviews($("sort").value);
  }
  function paintReviews(mode){
    var r = (F.rv || []).slice();
    if(mode === "high") r.sort(function(a,b){ return b.s - a.s; });
    else if(mode === "low") r.sort(function(a,b){ return a.s - b.s; });
    else r.sort(function(a,b){ return a.d < b.d ? 1 : -1; });
    $("rvlist").innerHTML = r.map(function(v){
      var when = v.d;
      if(/^\d{4}-\d{2}-\d{2}$/.test(v.d)){
        var d = new Date(v.d + "T00:00:00");
        when = d.toLocaleDateString("en-US", { month:"short", day:"numeric", year:"numeric" });
      }
      return '<article class="rv">' +
        '<div class="rv-top"><span class="st">' + stars(v.s) + '</span>' +
        '<span class="who">' + v.a + '</span>' +
        '<span class="ver">Verified buyer</span>' +
        '<span class="when">' + when + '</span></div>' +
        (v.t ? '<h3 class="rv-t">' + v.t + '</h3>' : "") +
        (v.b ? '<p>' + v.b + '</p>' : "") + '</article>';
    }).join("");
  }
  $("sort").addEventListener("change", function(){ paintReviews(this.value); });
  /* ---------- Judge.me -> the Starpil review list ----------
     The widget below is the only source of individual reviews (Liquid gets
     the rating and the count, nothing more). Harvest what it rendered, paint
     it in our markup, then hide it. Hidden, not removed: Judge.me keeps
     running, and if this ever fails to find anything the widget is simply
     left visible, which is a working page rather than an empty one. */
  (function harvestJudgeme(){
    var mount = document.getElementById("judgeme_product_reviews");
    if(!mount) return;
    var done = false;
    function txt(n, sel){ var e = n.querySelector(sel); return e ? e.textContent.trim() : ""; }
    function harvest(){
      if(done) return true;
      var nodes = mount.querySelectorAll(".jdgm-rev");
      if(!nodes.length) return false;
      var out = [];
      Array.prototype.forEach.call(nodes, function(n){
        var rt = n.querySelector(".jdgm-rev__rating");
        var score = rt ? parseInt(rt.getAttribute("data-score"), 10) : 0;
        var tm = n.querySelector(".jdgm-rev__timestamp");
        var iso = tm ? String(tm.getAttribute("datetime") || "").slice(0, 10) : "";
        var who = txt(n, ".jdgm-rev__author") || "Verified buyer";
        var title = txt(n, ".jdgm-rev__title");
        var body = txt(n, ".jdgm-rev__body");
        var verified = n.getAttribute("data-verified-buyer") === "true";
        if(!title && !body) return;
        out.push({ s: score, a: who, d: iso, t: title, b: body });
      });
      if(!out.length) return false;
      F.rv = out;
      paintReviews($("sort") ? $("sort").value : "recent");
      var w = mount.querySelector(".jdgm-rev-widg") || mount;
      w.style.display = "none";
      done = true;
      return true;
    }
    if(harvest()) return;
    /* Judge.me paints asynchronously, and re-paints on its own pagination. */
    var obs = new MutationObserver(function(){ if(harvest()) obs.disconnect(); });
    obs.observe(mount, { childList: true, subtree: true });
    setTimeout(function(){ obs.disconnect(); }, 20000);
  })();


  /* ---------- comparison, scoped to this kit's template ---------- */
  function famKeys(){
    return ORDER.filter(function(k){ return KITS[k].family === F.family; });
  }
  function cmpCell(v){
    if(v === null || v === undefined) return "\u2014";
    var s = String(v).trim();
    return (s === "" || s === "null" || s === "undefined") ? "\u2014" : s;
  }
  function buildCompare(){
    var keys = famKeys();
    var cmpSec = $("compare");
    if(keys.length < 2){
      cmpSec.hidden = true; $("cmpBody").innerHTML = ""; $("cmpHead").innerHTML = ""; return;
    }
    cmpSec.hidden = false;
    var lab = (GROUPS.filter(function(g){ return g.family === F.family; })[0] || {}).label || F.template;
    $("cmpSub").textContent = "Every kit in this range, by price, options and who each one suits.";
    $("cmpHead").innerHTML = ["Kit","From","Options","In stock","Best for"]
      .map(function(h){ return "<th>" + h + "</th>"; }).join("");
    $("cmpBody").innerHTML = keys.map(function(k){
      var f = KITS[k];
      var prices = f.variants.map(function(v){ return v.price; });
      var vals = f.variants.map(function(v){ return v.value; }).filter(Boolean);
      var inst = f.variants.filter(function(v){ return v.avail; }).length;
      var isMe = k === CUR;
      return '<tr' + (isMe ? ' class="me"' : "") + '><td><b>' + f.name + '</b>' +
        (isMe ? '<span class="sub-note">You are here</span>' : "") + '</td>' +
        '<td>' + money(Math.min.apply(null, prices)) + '</td>' +
        '<td>' + f.variants.length + '</td>' +
        '<td>' + (inst ? inst + ' of ' + f.variants.length : "Sold out") + '</td>' +
        '<td class="bestfor">' + cmpCell(f.bestLine) + '</td></tr>';
    }).join("");
  }

  /* ---------- sticky bar ---------- */
  var atcEl = $("atc"), stickyEl = $("sticky"), popEl = $("stickypop");
  function closeSizePop(){
    popEl.hidden = true;
    $("stickysize").setAttribute("aria-expanded", "false");
  }
  function paintSticky(){
    var v = VARIANTS[sel];
    $("stickyimg").src = GAL.length ? THUMB(GAL[0]) : "";
    $("stickyimg").alt = "";
    $("stickytitle").textContent = F.name;
    $("stickysizetext").textContent = v.t + " \u00b7 " + (v.avail ? "in stock" : "sold out");
    $("stickyprice").textContent = money(v.price);
    // mirror the buy box: a sold-out option must not offer Add here either
    var sb = $("stickyatc");
    sb.textContent = v.avail ? "Add" : "Notify me";
  }
  $("stickysize").addEventListener("click", function(){
    var open = !popEl.hidden;
    popEl.hidden = open;
    this.setAttribute("aria-expanded", open ? "false" : "true");
  });
  $("spopclose").addEventListener("click", closeSizePop);
  function updateAll(){
    var show = atcEl.getBoundingClientRect().bottom < 0;
    stickyEl.setAttribute("data-show", show ? "1" : "0");
    if(!show && popEl && !popEl.hidden) closeSizePop();
  }
  window.addEventListener("scroll", updateAll, { passive: true });
  window.addEventListener("resize", updateAll);

  /* ---------- cart toast ---------- */
  var cart = 0;
  function showToast(msg){
    var t = $("toast");
    t.textContent = msg;
    t.setAttribute("data-show", "1");
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function(){ t.setAttribute("data-show", "0"); }, 2200);
  }
  /* Blockshop owns the cart drawer and the header count, so an add from this
     page should go through its API and behave like an add from anywhere else. */
  function themeCart(){
    var C = window.customElements && customElements.get("cart-element");
    return (C && typeof C.addItems === "function") ? C : null;
  }
  function refreshThemeCart(){
    var C = themeCart();
    if(!C || !C.updateTotals) return;
    var route = (window.Shopify && Shopify.routes ? Shopify.routes.cart : "/cart") + ".js";
    fetch(route).then(function(r){ return r.json(); })
      .then(function(c){ C.updateTotals(c.item_count); })
      .catch(function(){});
  }
  function addToCart(){
    var v = VARIANTS[sel];
    if(!v.avail){
      toast("<b>We'll email you</b> the moment " + v.t + " is back in stock.");
      return;
    }
    var body = spwForm ? new FormData(spwForm)
      : (function(){ var f = new FormData(); f.append("id", v.id); f.append("quantity", 1); return f; })();
    var C = themeCart();
    if(C){
      var secs = (C.sections || ["cart-drawer"]).join(",");
      C.addItems({
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(body).toString() + "&sections=" + secs
      }, $("atc")).then(function(){
        toast("<b>Added:</b> " + F.name + " " + v.t + ", " + money(v.price));
      }).catch(function(){
        toast("<b>Could not add to cart.</b> Please try again.");
      });
      return;
    }
    fetch("/cart/add.js", { method: "POST", headers: { "Accept": "application/json" }, body: body })
      .then(function(r){ if(!r.ok) throw new Error("cart " + r.status); return r.json(); })
      .then(function(){
        toast("<b>Added:</b> " + F.name + " " + v.t + ", " + money(v.price));
        refreshThemeCart();
      })
      .catch(function(){ toast("<b>Could not add to cart.</b> Please try again."); });
  }
  var spwForm = document.getElementById("spw-product-form");
  if(spwForm){
    spwForm.addEventListener("submit", function(e){ e.preventDefault(); addToCart(); });
  } else {
    $("atc").addEventListener("click", addToCart);
  }
  $("stickyatc").addEventListener("click", function(){
    if(spwForm && spwForm.requestSubmit) spwForm.requestSubmit();
    else addToCart();
  });

  /* ---------- desktop column balance (same approach as the other PDPs) ---- */
  /* Only blocks that actually live inside .buycol may be relocated. the components
     band and the comparison table are outside it. */
  var CANDIDATES = ["trust"].filter(function(id){
    var e = $(id);
    return e && e.closest && e.closest(".buycol");
  });
  var homes = {};
  CANDIDATES.forEach(function(id){
    var e = $(id);
    if(e) homes[id] = { parent: e.parentNode, next: e.nextSibling };
  });
  function restoreBlocks(){
    CANDIDATES.forEach(function(id){
      var e = $(id), h = homes[id];
      if(e && h && e.parentNode !== h.parent) h.parent.insertBefore(e, h.next);
    });
  }
  function leftHeight(gal, side){
    if(!side.children.length) return gal.offsetHeight;
    return Math.round(side.getBoundingClientRect().bottom - gal.getBoundingClientRect().top);
  }
  function balanceColumns(){
    restoreBlocks();
    var side = $("sidecol"), buy = document.querySelector(".buycol"),
        gal = document.querySelector(".galcol");
    if(!side || !buy || !gal) return;
    if(document.body.getAttribute("data-view") === "mobile" || window.innerWidth < 901) return;
    var items = [];
    CANDIDATES.forEach(function(id){
      var e = $(id);
      if(e && !e.hidden && e.offsetParent !== null) items.push(e);
    });
    if(!items.length) return;
    var best = { diff: Math.abs(gal.offsetHeight - buy.offsetHeight), mask: 0 };
    for(var mask = 1; mask < (1 << items.length); mask++){
      restoreBlocks();
      for(var i = 0; i < items.length; i++) if(mask & (1 << i)) side.appendChild(items[i]);
      var diff = Math.abs(leftHeight(gal, side) - buy.offsetHeight);
      if(diff < best.diff) best = { diff: diff, mask: mask };
    }
    restoreBlocks();
    for(var j = 0; j < items.length; j++) if(best.mask & (1 << j)) side.appendChild(items[j]);
  }
  var balTimer = null;
  function scheduleBalance(){ clearTimeout(balTimer); balTimer = setTimeout(balanceColumns, 60); }
  window.addEventListener("resize", scheduleBalance);

  /* ---------- render / mount ---------- */
  function render(){
    buildSizes($("sizes"));
    buildSizes($("spopsizes"), function(){ closeSizePop(); });
    paintPrice();
    paintKit();
    paintSticky();
    updateAll();
  }
  function mountKit(key){
    CUR = key; F = KITS[key];
    VARIANTS = F.variants; GAL = F.gal;
    sel = firstBuyable(); galIdx = 0;
    paintCopy();
    buildThumbs(); paintGallery();
    buildCompare();
    render();
    scheduleBalance();
  }

  mountKit(CUR);
})();
